module.exports = __webpack_public_path__ + "resources/f82cba211182fbb07d3510cbe89c7ccb.otf";


//////////////////
// WEBPACK FOOTER
// ./resources/fonts/CompactaBT-Italic.otf
// module id = 217
// module chunks = 0